import React from 'react'
import SingleSelect from '../singleSelect/SingleSelect.component'
import { useDispatch, useSelector } from 'react-redux'
import { getPNNVStateSelector } from './selectors'
import { IPNNVState } from './store/pnnv.types'
import {
  resetPNNVState,
  setNumberPadAndCalendarCurrentPNNVValue,
  setFreeTextFieldCurrentPNNVValue,
} from './store/pnnv.actions'
import { IPNNVOption } from '../../common/common.types'

interface IPNNVBar {
  nonPNNVDataReset?: () => void
  actionOnDone?: () => void
  pnnvRenderedFromFreeTextField?: boolean
  showSingleSelectPopup?: boolean
  hidePopup?: () => void
  actionOnCannotComplete?: () => void
}

const PNNVBar: React.FC<IPNNVBar> = (props) => {
  const {
    nonPNNVDataReset,
    actionOnDone,
    pnnvRenderedFromFreeTextField,
    showSingleSelectPopup,
    hidePopup,
    actionOnCannotComplete,
  } = props
  const dispatch = useDispatch()
  const pnnvState: IPNNVState = useSelector(getPNNVStateSelector)
  const { numberPadAndCalendar, freeTextField, preventResetIdentifiers } = pnnvState

  const getRequiredPNNVComponent = () => {
    // Why: This function prevents execution of nonPNNVDataReset when a specific PNNV value is selected.
    const shouldResetData = (e: IPNNVOption) => {
      if (preventResetIdentifiers.includes(e?.id)) return false
      return true
    }

    if (pnnvRenderedFromFreeTextField) {
      if (freeTextField.options.length) {
        return (
          <SingleSelect
            dataTestID='pnnv-option-select'
            options={freeTextField.options}
            selectedOption={freeTextField.currentPNNVValue}
            listHeader={freeTextField.pnnvListHeader}
            label={freeTextField.pnnvLabel}
            nemsis={freeTextField.nemsis}
            action={(e: IPNNVOption, dispatchData?: any) => {
              shouldResetData(e) && nonPNNVDataReset && nonPNNVDataReset()
              freeTextField.onPNNVChangeHandler(e, dispatchData)
              dispatch(setFreeTextFieldCurrentPNNVValue(e))
            }}
            shouldRenderPNNVBar={true}
            pnnvDoneAction={() => dispatch(resetPNNVState())}
            pnnvRenderedFromFreeTextField={pnnvRenderedFromFreeTextField}
            showSingleSelectPopup={showSingleSelectPopup}
            hidePopup={hidePopup}
            actionOnCannotComplete={actionOnCannotComplete}
          />
        )
      }
    } else {
      if (numberPadAndCalendar.options.length) {
        return (
          <SingleSelect
            dataTestID='pnnv-option-select'
            options={numberPadAndCalendar.options}
            selectedOption={numberPadAndCalendar.currentPNNVValue}
            listHeader={numberPadAndCalendar.pnnvListHeader}
            label={numberPadAndCalendar.pnnvLabel}
            nemsis={numberPadAndCalendar.nemsis}
            action={(e: IPNNVOption, dispatchData?: any) => {
              shouldResetData(e) && nonPNNVDataReset && nonPNNVDataReset()
              numberPadAndCalendar.onPNNVChangeHandler(e, dispatchData)
              dispatch(setNumberPadAndCalendarCurrentPNNVValue(e))
            }}
            shouldRenderPNNVBar={true}
            pnnvDoneAction={actionOnDone}
            pnnvRenderedFromFreeTextField={pnnvRenderedFromFreeTextField}
            showSingleSelectPopup={showSingleSelectPopup}
            hidePopup={hidePopup}
            actionOnCannotComplete={actionOnCannotComplete}
          />
        )
      }
    }
    return null
  }

  return <>{getRequiredPNNVComponent()}</>
}
export default PNNVBar
